import { useCallback } from 'react'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'

import type { DialogProps } from '../types'

interface Props extends DialogProps {
  onSubmit: (listId: number) => void
  listId: number
}

export const RecentSpenderDeleteDialog = ({
  isOpen,
  onClose,
  onSubmit,
  listId,
}: Props) => {
  const handleSubmit = useCallback(() => {
    onSubmit(listId)
    onClose()
  }, [onSubmit, listId, onClose])

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      panelClassName="w-[400px]"
      testId="confirmation-dialog"
    >
      <Dialog.Header>
        <Dialog.Title>Delete Spend List</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description>
        <div className="flex flex-col gap-6 pt-6">
          <p className="text-center text-sm text-gray-500 dark:text-gray-300">
            Delete the spend list you selected will delete it permanently.
          </p>
        </div>
      </Dialog.Description>
      <Dialog.Footer>
        <div className="flex w-full justify-end gap-2">
          <Button
            className="flex-1"
            variant="outline"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="flex-1"
            variant="destructive"
            onClick={handleSubmit}
            testId="delete-list-confirm-button"
          >
            Delete
          </Button>
        </div>
      </Dialog.Footer>
    </Dialog>
  )
}
